<template>
	<aside class="maps">
		<div class="selected-provider">
			<p class="selected-provider__header">Your Selected Location</p>
			<provider :data="selectedMarker"></provider>
		</div>
		<div class="google-maps"></div>
		<div class="maps-hover">
			<div class="content">
				<provider :data="hoveredMarker"></provider>
			</div>
		</div>
	</aside>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import EventBus from '../../../js/eventBus'
import gmapsInit from "../../../js/gmaps";
import Services from '../../mixins/services';
import Provider from './provider'

import moment from "moment";

export default {
	mixins: [Services],
	props: ['searchString'],
	components: {
		Provider
	},
	data: function () {
		return {
			google: null,
			geocoder: null,
			map: null,
			map_options: {},
			address_components: [],
			markers: [],
			selectedMarker: null,
			hoveredMarker: null,
			bounds: null,
			infoWindow: null,
		}
	},
	computed: mapState({
		globals: state => state.LocationSearch.globals,
		geoLocation: state => state.LocationSearch.geoLocation,
		firstResults: state => state.LocationSearch.firstResults,
	}),
	methods: {
		async drop_pins() {
			this.address_components = this.firstResults.reduce(
				async (accu, location, i) => {
					const address_components = await accu;
					await new Promise((resolve) => {
						const marker = this.createMarker(location)
						this.bounds.extend(marker.getPosition());
						this.markers.push(marker);
						marker.addListener("click", () => {
							this.selectedMarker = marker.__meta;
						});
						marker.addListener('mouseover', (e) => {
							this.markerOnMouseover(marker);
						});
						marker.addListener('mouseout', () => {
							this.markerOnMouseout();
						});

						resolve(marker);
					});
					address_components.push(location);
					this.map.fitBounds(this.bounds); //auto-zoom
					return address_components;
				},
				Promise.resolve([])
			);
		},
		markerOnMouseover(marker) {
			if (this.hoveredMarker) {
				return;
			} else {
				this.hoveredMarker = marker.__meta;
				const scale = Math.pow(2, this.map.getZoom());
				const nw = new this.google.maps.LatLng(
					this.map.getBounds().getNorthEast().lat(),
					this.map.getBounds().getSouthWest().lng()
				);
				const worldCoordinateNW = this.map.getProjection().fromLatLngToPoint(nw);
				const worldCoordinate = this.map.getProjection().fromLatLngToPoint(marker.getPosition());
				const markerOffset = new this.google.maps.Point(
					Math.floor((worldCoordinate.x - worldCoordinateNW.x) * scale),
					Math.floor((worldCoordinate.y - worldCoordinateNW.y) * scale)
				);
				const mapOffset = document.querySelector(".google-maps").getBoundingClientRect();
				const providerEl = document.querySelector(".maps-hover");
				const providerElOffset = providerEl.getBoundingClientRect();
				providerEl.style.visibility = "visible";
				
				providerEl.style.top = `${(mapOffset.y + markerOffset.y) - (providerElOffset.height / 2) - 50}px`;
				providerEl.style.left = `${(mapOffset.x + markerOffset.x) - (providerElOffset.width) - 30}px`;
			}
		},
		markerOnMouseout() {
			const providerEl = document.querySelector(".maps-hover");
			providerEl.style.visibility = "hidden";
			this.hoveredMarker = null;
		},
		createMarker(el) {
			return new this.google.maps.Marker({
				map: this.map,
				id: el.id,
				icon: {
					url: 'images/map-marker-blue.svg',
					scaledSize: new google.maps.Size(60, 90),
				},
				position: {
					lat: parseFloat(el.latitude),
					lng: parseFloat(el.longitude),
				},
				__meta: {
					id: el.id,
					...el,
				}
			});
		},
		async searchLocations() {
			this.selectedMarker = this.firstResults[0];
			this.bounds = new google.maps.LatLngBounds();
			
			if (this.firstResults.length > 1) {
				this.address_components = [];
				this.markers.forEach(function(marker) {
					marker.setMap(null);
				});
				this.markers = [];
				
				await this.drop_pins();
				this.map.fitBounds(this.bounds); //auto-zoom
			} else {
				const searched_component = await this.create_address_component({address: this.searchString});
				let latLng = new this.google.maps.LatLng(searched_component.geometry.location.lat(), searched_component.geometry.location.lng());
				this.map.setCenter(latLng);
				this.map.setZoom(12);
			}
		},
		create_address_component(location) {
			return new Promise((resolve) => {
				this.geocoder.geocode(
					{ address: location.address },
					(result, status) => {
						if (status !== "OK" || !result[0]) {
							resolve(false);
						}
						resolve(result[0]);
					}
				);
			});
		},
		init() {
			return new Promise(async resolve => {
				this.google = await gmapsInit(this.globals.apiKey);
				this.geocoder = new this.google.maps.Geocoder();

				this.map_options = {
					clickableIcons: false,
					gestureHandling: "cooperative",
					disableDefaultUI: true,
					zoom: 12,
				};

				if (this.geoLocation) {
					this.map_options.center = new this.google.maps.LatLng(
						this.geoLocation.latitude,
						this.geoLocation.longitude
					);
				}

				this.map = new this.google.maps.Map(
					document.getElementsByClassName("google-maps")[0],
					this.map_options
				);
				resolve();
			})
		}
	},
	async mounted() {
		await this.init();
		if (this.firstResults.length > 0) {
			await this.searchLocations();
		}
	}
}
</script>